import { useEffect, useState, useMemo } from 'react';
import { FILTERS } from './constants';
import { FilteredFilter } from './types';
import { useUserProductsAndTenorsContext } from '@shared/contexts/UserProductsAndTenorsProvider';
export const useProductFinder = () => {
  const [selectedFilters, setSelectedFilters] = useState<Record<string, string[]>>({});
  const { userProducts } = useUserProductsAndTenorsContext();
  const [showCopySuccess, setShowCopySuccess] = useState(false);
  const [filteredFilters, setFilteredFilters] = useState<FilteredFilter[]>(FILTERS.map(filter => ({ ...filter, filteredOptions: filter.options })));
  const [search, setSearch] = useState('');
  const filteredProducts = useMemo(() => {
    const updatedProducts = userProducts?.filter(product => {
      return Object.entries(selectedFilters).every(([filterId, options]) => {
        if (options?.length === 0) return true;
        const productValue = product[filterId];
        return options?.includes(productValue);
      });
    });
    if (search) {
      return updatedProducts.filter(product => product.symbol.toLowerCase().includes(search.toLowerCase()));
    }

    return updatedProducts;
  }, [userProducts, selectedFilters, search]);

  useEffect(() => {
    const newFilteredFilters = FILTERS.map(filter => {
      const selectedOptions = selectedFilters[filter.id] || [];
      const availableOptions = new Set(userProducts?.map(product => product[filter.id]));
      const filteredOptions = filter.options.filter(option => selectedOptions.includes(option) || availableOptions.has(option));

      return {
        ...filter,
        filteredOptions,
      };
    });

    setFilteredFilters(newFilteredFilters);
  }, [userProducts, selectedFilters]);

  useEffect(() => {
    const initialFilters: Record<string, string[]> = {};
    FILTERS.forEach(filter => {
      initialFilters[filter.id] = [];
    });
    setSelectedFilters(initialFilters);
  }, []);

  const onFilterChange = (filterId: string, option: string) => {
    setSelectedFilters(prev => {
      const currentOptions = prev[filterId] || [];
      const newOptions = currentOptions.includes(option) ? currentOptions.filter(opt => opt !== option) : [...currentOptions, option];

      return {
        ...prev,
        [filterId]: newOptions,
      };
    });
  };

  const onCopy = () => {
    const productSymbols = filteredProducts.map(product => product.symbol);
    navigator.clipboard.writeText(productSymbols.join('\n'));
    setShowCopySuccess(true);
  };

  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };
  return {
    filteredProducts,
    filteredFilters,
    selectedFilters,
    onFilterChange,
    onSearch,
    onCopy,
    showCopySuccess,
    setShowCopySuccess,
  };
};
